<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title
        >接口用户管理
        <template slot="operate">
          <el-button
            v-if="operationSuper.删除"
            class="g-form-section-search operate__item"
            icon="e6-icon-clear_line"
            title="删除"
            @click="handleBatchDeleteInterfaceUserInfo"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            icon="e6-icon-add_line"
            title="添加"
            @click="$router.push('/systemSettingInterfaceUserManagerEdit')"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.customerName">
            <el-input
              v-model="slotForms.forms.appKey"
              placeholder="appKey"
              clearable
            ></el-input>
          </el-form-item>
          <!--<el-form-item prop="forms.regName">-->
          <!--<el-input-->
          <!--v-model="slotForms.forms.userNickName"-->
          <!--placeholder="用户别名"-->
          <!--clearable-->
          <!--&gt;</el-input>-->
          <!--</el-form-item>-->
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->

    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          label="序号"
          width="50"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column label="appKey" fixed prop="appKey"></el-table-column>
        <el-table-column
          label="appSecret"
          fixed
          prop="appSecret"
        ></el-table-column>
        <!--<el-table-column label="ip" prop="ip"></el-table-column>-->
        <!--<el-table-column label="业务id" prop="businessId"></el-table-column>-->
        <el-table-column label="企业名称" prop="userNickName"></el-table-column>
        <el-table-column label="企业类型" prop="useType">
          <template slot-scope="scope">
            <label v-if="scope.row.useType == 1">服务商</label>
            <label v-if="scope.row.useType == 2">企业</label>
          </template>
        </el-table-column>
        <el-table-column prop="isAbleUse" label="状态" width="90">
          <template slot-scope="scope">
            <el-button v-if="scope.row.isAbleUse === 1" round type="success"
              >正常
            </el-button>
            <el-button v-if="scope.row.isAbleUse === 0" round type="danger"
              >禁用
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="接口数量" prop="interfaceNum"></el-table-column>
        <el-table-column
          align="center"
          fixed="right"
          :label="$t('_private.button.operate')"
          width="120"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.isAbleUse === 1 && operationSuper.编辑"
              type="text"
              round
              @click="changeIsAbleUse(scope.row)"
              >禁用
            </el-button>
            <el-button
              v-if="scope.row.isAbleUse === 0 && operationSuper.编辑"
              type="text"
              round
              @click="changeIsAbleUse(scope.row)"
              >启用
            </el-button>
            <router-link
              v-if="operationSuper.编辑"
              :to="{
                path: '/systemSettingInterfaceUserManagerEdit',
                query: { pageType: '2', appId: scope.row.appId }
              }"
              >编辑
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 批量删除确认 -->
    <e6-message-box
      :messageBoxVisible.sync="messageBoxVisible"
      @messageBoxSubmit="handleMessageBoxSubmit"
    >
      <div class="batch-delete">确定删除所选数据？</div>
    </e6-message-box>
    <!-- 批量删除确认 end -->
  </div>
</template>

<script>
import {
  DeleteInterfaceUserInfo,
  FetchByPage,
  ChangeStatus
} from "@/api/systemSetting/interfaceUserManager";
import { mapGetters } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import { mergeFormExtend } from "_private/utils/merge";
import operationManage from "_private/mixins/operationManage";

export default {
  mixins: [resizeListener, operationManage],
  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: true,
      formExtend: {
        forms: {},
        extends: []
      },
      tableData: [],
      multipleSelection: [],
      messageBoxVisible: false
    };
  },
  computed: {
    ...mapGetters(["moduleId", "userId"]),
    appIds() {
      let ids = this.multipleSelection.map(item => {
        return item.appId;
      });
      return ids.length < 1 ? "" : ids.join(",");
    }
  },
  created() {
    this.FetchByPage(this.mergeObj());
  },
  methods: {
    changeIsAbleUse(row) {
      let data = { interfaceId: row.appId, status: row.isAbleUse };
      ChangeStatus(data)
        .then(response => {
          let type = response.code === 1 ? "success" : "error";
          let message = response.message;
          this.$message({
            showClose: true,
            message: message,
            type: type,
            duration: 2000,
            onClose: () => {
              if (type === "success") {
                this.FetchByPage(this.mergeObj());
              }
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取表格数据
    FetchByPage(data) {
      FetchByPage(data)
        .then(response => {
          if (
            response.result &&
            response.result.data &&
            Array.isArray(response.result.data)
          ) {
            this.tableData = response.result.data;
            this.total = response.result.totalRecords;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 删除
    DeleteInterfaceUserInfo(data) {
      DeleteInterfaceUserInfo(data)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        moduleId: this.moduleId,
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    submitCallback(data) {
      let type = data.code === 1 ? "success" : "error";
      let message = data.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.curPage = 1;
            this.FetchByPage(this.mergeObj());
          }
        }
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchByPage(this.mergeObj());
    },
    // handleResetForm() {
    //   this.$refs.selectTree.handleclear();
    // },
    // 表格选择改变事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchByPage(this.mergeObj());
    },
    // 打开确认删除面板
    handleBatchDeleteInterfaceUserInfo() {
      if (this.appIds === "") {
        return this.$message({
          showClose: true,
          message: "至少选择一条数据",
          type: "error",
          duration: 1200
        });
      }
      this.messageBoxVisible = true;
    },
    // 确认删除
    handleMessageBoxSubmit() {
      this.DeleteInterfaceUserInfo({ ids: this.appIds });
    },
    handleResetForm() {
      this.formExtend.forms.appKey = null;
      this.formExtend.forms.userNickName = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
</style>
